<!--抽奖活动-->
<template>
  <div class="luckDraw_body">
      <div class="luckDraw">
    <div class="rulebtn" @click="showRule()">活动规则</div>
    <div class="prizebox">
      <h2>乐铺感恩大回馈，自活动开始起，凡购买VIP即可参与抽奖活动，有机会获得最高999元现金返现。</h2>
      <div class="activiebox">
        <div class="luck-wrapper">
          <ul class="nineGrid">
            <li class="row">
              <div v-for="(n,key) in 3" :key="n" :class="index===key?'active':''">
                <div class="box">
                </div>
              </div>
            </li>
            <li class="row">
              <div :class="index === 7 ? 'active': ''">
                <div class="box">
                </div>
              </div>
              <div :class="['getLuck',!click?'select':'']" @click="getPrize" >
                <p><img src="//assets.lepucdn.cn/vue/images/zhuanti/luckdraw/getluck.png" alt=""></p>
              </div>
              <div :class="index === 3 ? 'active': ''">
                <div class="box">
                </div>
              </div>
            </li>
            <li class="row">
              <div v-for="(n, key) in 3" :key="n" :class="index === 6-key ? 'active' : ''">
                <div class="box">
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="activetime">本次活动时间：2019年3月20日至2019年10月31日</div>
    </div>

    <div :class="['rule_layerbg',isrule?'show':'']" @click="closeRule"></div>
    <div :class="['rule_layer',isrule?'zoomIn':'hide']">
      <h2>活动规则</h2>
      <ul>
        <li>1、用户每次购买完VIP会员都可以获得一次抽奖机会，面额最高999元。</li>
        <li>2、返现奖金将在7个工作日内由乐铺工作人员联系您并退回到您的账户。</li>
        <li>3、用户可能遇到打款失败/账号异常行为未领取到返现金额，可联系乐铺客服人员。</li>
        <li>4、若使用非正常手段获取活动奖励（包括但不限于使用非法技术行为骗取），乐铺有权不发放奖励现金，并将视情况追究法律责任。</li>
        <li>5、若用户在服务期内申请会员退费，且参与抽奖活动，退款金额将自动扣除返现活动的金额。</li>
      </ul>
      <div class="rule_tips">*活动最终解释权归乐铺所有</div>
    </div>
    <!--奖品弹框-->
    <div :class="['rule_layerbg',isPrize?'show':'']" @click="closeRule"></div>
    <div :class="['prizeLayer',isPrize?'zoonIn':'hide']">
      <div>
        <h2>恭喜您获得现金</h2>
        <h3>￥<b>{{prizeName}}</b></h3>
        <p>返现奖金将在7个工作日内由</p>
        <p>乐铺工作人员联系您并退回到您的账户</p>
        <span @click="closePrize">我知道了</span>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import '../../../static/css/base.css';
  import wcache from '../../../static/js/wcache';
  import axios from 'axios';
  import qs from 'qs';
  import '../../../static/css/layer.css';
  import '../../../static/js/layer.js'


  export default {
    name: 'luckdraw',
    data () {
      return {
        index: -1,    // 当前转动到哪个位置，起点位置
        count: 8,    // 总共有多少个位置
        timer: 0,    // 每次转动定时器
        speed: 150,   // 初始转动速度
        times: 0,    // 转动次数
        cycle: 8,   // 转动基本次数：即至少需要转动多少次再进入抽奖环节
        prize: -1,   // 中奖位置
        click: true,
        isrule:false,
        prizeName:'',//奖品名称
        prizePos:'',//奖品位置
        prizeObj:{
          '20':0,
          '60':1,
          '30':2,
          '199':3,
          '999':4,
          '399':5,
          '299':6,
          '50':7
        },
        isPrize:false,
        city:1,
      }
    },
    created(){
        if(JSON.stringify(this.$route.query) != '{}' && this.$route.query.city != 'undefined' && this.$route.query.city != undefined){
            this.city = this.$route.query.city
        }
    },
    methods:{
      //获取奖品
      getPrize(){
        let url='//api.lepu.cn/app/order/vip-lottery?city='+this.city;
        axios.get(url).then(res=>{
          console.log(141,res)
          console.log(142,res.data.data.code)
          if(res.status){
            if(res.data.data.code==1){
              this.prizeName=res.data.data.data.price;
              this.startLottery()
              for(let i in this.prizeObj){
                this.prizePos=this.prizeObj[this.prizeName]
              }
            }else if(res.data.data.code==50013){
                this.$toast({
                    message: res.data.note,
                    position: "middle",
                    duration: 2000
                });
            }else{
                this.$toast({
                    message: res.data.note,
                    position: "middle",
                    duration: 2000
                });
            }
          }
        })
      },
      // 开始抽奖
      startLottery () {
        if (!this.click) {
          console.log(164,this.click)
          return
        }
        this.speed = 150
        this.click = false
        this.startRoll()
      },
      // 开始转动
      startRoll () {
        this.times += 1  // 转动次数
        this.oneRoll()  // 转动过程调用的每一次转动方法，这里是第一次调用初始化
        // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
        console.log(this.times,this.cycle,this.speed,this.prize,this.index)
        if (this.times > this.cycle + 10 && this.prize === this.index) {
          clearTimeout(this.timer)   // 清除转动定时器，停止转动
          this.times = 0
          //this.showToast = true
          //this.toastType = 'comeOn'
          console.log('你已经中奖了')
          var that = this
          setTimeout(function(){
            that.isPrize=true;
            that.prize = -1
            that.index = -1
            that.click = true
          },300)
        } else {
          if (this.times < this.cycle) {
            this.speed -= 10   // 加快转动速度
          } else if (this.times === this.cycle) {
            const index = this.prizePos;
            this.prize = index
            if (this.prize > 7) {
              this.prize = 7
            }
          }
          if (this.speed < 40) {
            this.speed = 40
          }
          this.timer = setTimeout(this.startRoll, this.speed)
        }
      },

      // 每一次转动
      oneRoll () {
        let index = this.index  // 当前转动到哪个位置
        const count = this.count  // 总共有多少个位置
        index += 1
        if (index > count - 1) {
          index = 0
        }
        this.index = index
      },
      //显示活动规则
      showRule(){
        this.isrule=true
      },
      //关闭活动规则
      closeRule(){
        this.isrule=false
      },
      //关闭奖品弹框
      closePrize(){
        this.isPrize=false
      }
    }
  }
</script>
<style>
  .luckDraw_body{
      width: 100%;
      height: 100%;
      overflow: scroll;
      position: relative;
      background: #d73637;
  }
  #luckDraw {
    width: 100%;
    height:100%;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .luckDraw{
    width: 100%;
    height:12.18rem;
    background: url('//assets.lepucdn.cn/vue/images/zhuanti/luckdraw/bg.png') no-repeat;
    -webkit-background-size: 100% 100%;
    background-size: 100% 100%;
    position: absolute;
    padding: 2.94rem .58rem 0 0.5rem ;
  }
  .rulebtn{
    position: absolute;
    right:0;
    top:0.3rem;
    width:1.42rem;
    height:0.46rem;
    line-height:0.46rem;
    background: #fff;
    text-align: center;
    font-size:0.26rem;
    color: #f7b33d;
    border-bottom-left-radius:0.6rem ;
    border-top-left-radius: 0.6rem;
  }
  .prizebox{
    width: 100%;
    height:7.99rem;
    background:url('//assets.lepucdn.cn/vue/images/zhuanti/luckdraw/prizebg.png')no-repeat ;
    -webkit-background-size: 100% 100%;
    background-size: 100% 100%;
  }
  .prizebox h2{
    width: 100%;
    height:1.05rem;
    font-size:0.25rem;
    color: #dc4a39;
    text-align: justify;
    padding:.17rem .39rem 0 .41rem;
    margin-bottom: 0.76rem;
  }
  .activiebox{
    width: 100%;
    height: 5.7rem;
    border-radius:0.4rem ;
    padding: 0.02rem 0.36rem;
  }
  .luck-wrapper{
    width: 100%;
    height:100%;
    position: relative;
  }

  .integral span {
    font-weight: 600;
    color: #ff2f4d;
  }
  .nineGrid{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .nineGrid li{
    height: 1.82rem;
    display: flex;
    margin: .06rem 0 .06rem 0;
  }
  .nineGrid li>div{
    flex: 1;
    margin: 0 .04rem;
    height: 100%;
    text-align: center;
    position: relative;
    background: #fff;
    border-radius: .26rem;
  }

  .nineGrid li .box{
    position: absolute;
    left:.06rem;
    top:.02rem;
    width: 1.7rem;
    height: 1.7rem;
  }
  .nineGrid .row>div.active{
    background: #ffe032;
  }
  .nineGrid .row:first-child>div:first-child .box{
    background: url('//assets.lepucdn.cn/vue/images/zhuanti/luckdraw/20.png') no-repeat;
    background-size: 100% 100%;
  }
  .nineGrid .row:first-child>div:nth-of-type(2) .box{
    background: url('//assets.lepucdn.cn/vue/images/zhuanti/luckdraw/60.png') no-repeat;
    background-size: 100% 100%;
  }
  .nineGrid .row:first-child>div:last-child .box{
    background: url('//assets.lepucdn.cn/vue/images/zhuanti/luckdraw/30.png') no-repeat;
    background-size: 100% 100%;
  }
  .nineGrid .row:nth-of-type(2)>div:first-child .box{
    background: url('//assets.lepucdn.cn/vue/images/zhuanti/luckdraw/50.png') no-repeat;
    background-size: 100% 100%;
  }
  .nineGrid .row:nth-of-type(2)>div:last-child .box{
    background: url('//assets.lepucdn.cn/vue/images/zhuanti/luckdraw/199.png') no-repeat;
    background-size: 100% 100%;
  }
  .nineGrid .row:last-child>div:first-child .box{
    background: url('//assets.lepucdn.cn/vue/images/zhuanti/luckdraw/299.png') no-repeat;
    background-size: 100% 100%;
  }
  .nineGrid .row:last-child>div:nth-of-type(2) .box{
    background: url('//assets.lepucdn.cn/vue/images/zhuanti/luckdraw/399.png') no-repeat;
    background-size: 100% 100%;
  }
  .nineGrid .row:last-child>div:last-child .box{
    background: url('//assets.lepucdn.cn/vue/images/zhuanti/luckdraw/999.png') no-repeat;
    background-size: 100% 100%;
  }
  .getLuck{
    width: 100%;
    height:100%;
    background: #d52d3a!important;
  }
  .getLuck p{
    width: 100%;
    height: 1.7rem;
    border-radius: 0.26rem;
    background: #f7524b;
    padding-top: 0.2rem;
    box-sizing: border-box;
  }
  .getLuck.select p{
    background: #d52d3a;
  }
  .getLuck p img {
    width: 1.1rem;
    height: 1.2rem;
    margin: 0 auto;
  }
  .activetime{
    text-align: center;
    font-size:0.24rem;
    line-height:0.24rem;
    color: #fff;
    margin-top: .8rem;
  }
  /*活动规则弹框*/
  .rule_layerbg{
    display: none;
    position: fixed;
    left:0;
    top:0;
    width: 100%;
    height:100%;
    background: rgba(0,0,0,0.5);
  }
  .rule_layer{
    position: absolute;
    left:50%;
    top:50%;
    margin: -3.79rem 0 0 -3.25rem;
    width: 6.5rem;
    background: #fff;
    border-radius: 0.26rem;
    color: #333;
    padding-bottom: 0.38rem;
  }
  .rule_layer h2{
    width: 100%;
    height: .9rem;
    line-height:.9rem;
    font-size:0.32rem;
    border-bottom: 0.01rem solid #ddd;
    text-align: center;
  }
  .rule_layer ul{
    padding: 0.38rem 0.45rem 0;
  }
  .rule_layer ul li{
    line-height:0.44rem;
    font-size:0.24rem;
    z-index: 100;
    text-align: justify;
  }
  .rule_tips{
    font-size:0.24rem;
    line-height:0.24rem;
    color: #999;
    margin-top: 0.36rem;
    text-align: center;
  }
  .show{
    display: block;
  }
  .hide{
    display: none;
  }
  .zoomIn {
    opacity: 1;
    transform: scale(1);
    -webkit-transform: scale(1);
    transition: all ease 0.3s;
    -webkit-transition: all ease 0.3s;
  }

  .zoomOut {
    opacity: 0;
    transform: scale(0);
    -webkit-transform: scale(0);
    transition: all ease 0.3s;
    -webkit-transition: all ease 0.3s;
  }
  /*奖品弹框*/
  .prizeLayer{
    position: absolute;
    left:50%;
    top:1.12rem;
    margin-left: -3.38rem;
    width:6.78rem ;
    height:7.88rem;
    background: url('//assets.lepucdn.cn/vue/images/zhuanti/luckdraw/framebg.png')no-repeat;
    background-size: 100% 100%;
    padding: 3.72rem 0.4rem 0;
    color: #fff;
    text-align: center;
  }
  .prizeLayer h2{
    font-size:0.38rem;
    line-height:0.38rem;
    font-weight:bold;
    margin-bottom: 0.3rem;
  }
  .prizeLayer h3{
    font-size:.6rem;
    height:.9rem;
    line-height:.9rem;
    font-weight:bold;
    color: #ffec91;
    text-shadow: 0 .07rem #f0a467;
    margin-bottom: 0.32rem;
  }
  .prizeLayer h3 b{
    display: inline-block;
    line-height:.9rem;
    font-size:.9rem;
    font-weight:bold;
  }
  .prizeLayer p{
    line-height:0.44rem;
    font-size:0.28rem;
  }
  .prizeLayer span{
    display: block;
    width: 2.28rem;
    height:.66rem;
    line-height:.66rem;
    background: #fee984;
    font-size:0.26rem;
    color: #f5403c;
    margin: 0.3rem auto 0;
    -webkit-border-radius: 0.33rem;
    -moz-border-radius: 0.33rem;
    border-radius: 0.33rem;
  }
</style>
